import { createGeometryApi } from "@org-avp/avp-avengers-geometry-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const defaultPageSize = 5_000;
const baseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: environment.NX_GEOMETRY_SERVICE_BASE_URL,
  prepareHeaders,
};

export const geometryApi = createGeometryApi({
  pageSize: defaultPageSize,
  baseQueryArgs,
});
